module.exports = __webpack_public_path__ + "static/media/madhucon1.15323448.png";